import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

/**
 * Local storage service
 * used to persist application data in observable key value a pair
 */
@Injectable({
  providedIn: 'root',
})
export class LocalStorageService extends StorageService {
  constructor() {
    super();
  }
}
